// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Xyux","image":"Header_image__2uI1G","name":"Header_name__ckLMQ","info":"Header_info__sCPlf","infoRow":"Header_infoRow__5xO-z"};